module.exports = __webpack_public_path__ + "img/32710-009.d5640a6a.jpg";